module.exports = __webpack_public_path__ + "static/media/nebel.7841b45b.svg";